(function () {
  'use strict';
  // Accessory colour options: show the photo assigned to the chosen variant.
  function init(scope) {
    (scope || document).querySelectorAll('[data-product]').forEach(function (root) {
      var main = root.querySelector('.gal .main img');
      if (!main) return;
      root.querySelectorAll('[data-variant-select] input[data-img]').forEach(function (r) {
        r.addEventListener('change', function () {
          var img = r.getAttribute('data-img');
          if (!img) return;
          main.removeAttribute('srcset');
          main.src = img;
          var base = img.split('?')[0];
          root.querySelectorAll('[data-thumbs] button').forEach(function (b) {
            b.setAttribute('aria-pressed', String((b.getAttribute('data-src') || '').split('?')[0] === base));
          });
        });
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* IB fix 16 Oct 2026: show a contact form's "Got it" message only on the form that was actually submitted.
   Shopify flags every contact form as posted when the URL has contact_posted=true. The submitted form's id
   is only in the URL hash (e.g. #QuoteForm). On those pages the theme keeps each form's fields in
   <template data-ib-fields>, and this restores them on the forms that were not submitted. */
(function () {
  'use strict';
  if (window.location.search.indexOf('contact_posted=') === -1) return;
  var submitted = window.location.hash.slice(1);
  if (!submitted) return;
  var skip = ['INPUT', 'SELECT', 'TEXTAREA', 'BUTTON', 'SCRIPT', 'TEMPLATE'];
  var templates = document.querySelectorAll('form template[data-ib-fields]');
  for (var i = 0; i < templates.length; i++) {
    var tpl = templates[i];
    var form = tpl.closest('form');
    if (!form || form.id === submitted) continue;
    var done = tpl.previousElementSibling;
    if (done && skip.indexOf(done.tagName) === -1) done.parentNode.removeChild(done);
    tpl.parentNode.replaceChild(tpl.content.cloneNode(true), tpl);
  }
})();
